import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Container, Typography, Box, CircularProgress, Button, Tabs, Tab, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import ClientProfile from './ClientProfile';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const ProfileEdit = () => {
  const { user, isProvider, isAdmin, isAuthenticated, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (authLoading) return;
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    if (isAdmin()) {
      navigate('/admin');
      return;
    }
  }, [authLoading, isAdmin, navigate, isAuthenticated]);

  if (authLoading) {
    return (
      <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Profil adatok betöltése...</Typography>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return (
      <Container maxWidth="md" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h6">Bejelentkezés szükséges a profil szerkesztéséhez</Typography>
      </Container>
    );
  }

  const tabsConfig = [
    {
      label: 'Saját profil',
      component: <ClientProfile embedded={true} />,
    },
  ];

  if (isProvider()) {
    tabsConfig.push({
      label: 'Szolgáltatói profil',
      component: (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <Typography variant="h6" gutterBottom>Szolgáltatói profil kezelése</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Kattintson az alábbi gombra a szolgáltatói adatai, galériája és űrlapjai szerkesztéséhez.
          </Typography>
          {user?.provider?.id ? (
            <Button
              variant="contained"
              onClick={() => navigate(`/admin/providers/edit/${user.provider.id}`)}
            >
              Szolgáltatói profil szerkesztése
            </Button>
          ) : (
            <Alert severity="warning">
              Még nem hozta létre szolgáltatói profilját.
              <Button variant="text" onClick={() => navigate('/dashboard')} sx={{ ml: 1 }}>
                Ugrás a Dashboardra
              </Button>
            </Alert>
          )}
        </Box>
      ),
    });
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Profil szerkesztése
      </Typography>

      {tabsConfig.length > 1 && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
          <Tabs value={currentTab} onChange={(_, v) => setCurrentTab(v)} aria-label="profile tabs">
            {tabsConfig.map((tab) => (
              <Tab key={tab.label} label={tab.label} />
            ))}
          </Tabs>
        </Box>
      )}

      {tabsConfig.map((tab, index) => (
        <TabPanel key={tab.label} value={currentTab} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </Container>
  );
};

export default ProfileEdit;
